import { Component, OnInit, Input, HostListener, ViewChild, Output, EventEmitter, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';
import { AplicationStateService } from 'src/app/services/aplication-state.service';
import { Router } from '@angular/router';
import { InTheViewController } from 'src/app/services/InTheViewController';
import { TranslationService } from 'src/app/services/translation.service';
@Component({
  selector: 'app-product-avatar',
  templateUrl: './product-avatar.component.html',
  styleUrls: ['./product-avatar.component.css']
})
export class ProductAvatarComponent implements OnInit {

  imageSource: string;
  private inTheViewController: InTheViewController;
  public lang: string;

  @Input() product: any;
  @ViewChild('wrapper', {static: false}) wrapper: ElementRef;
  @ViewChild('tpl', {static: false}) tpl: TemplateRef<any>;
  @ViewChild('vc', {static: false, read: ViewContainerRef}) vc: ViewContainerRef;
  @Output() setfilter: EventEmitter<number> = new EventEmitter();

  @HostListener('mouseenter')
    onmouseover() {
      event.stopPropagation();
        if (this.product.imageOne){
          if (this.product.imageTwo != null) {
            this.imageSource = this.product.imageTwo.formats.thumbnail.url;
          } else {
            this.imageSource = this.product.imageOne.formats.thumbnail.url;
          }
        }else{
          if (this.product.secondaryImage != null) {
            this.imageSource = this.product.primaryImage.formats.thumbnail.url;
          } else {
            this.imageSource = this.product.secondaryImage.formats.thumbnail.url;
          }
        }
    }

  @HostListener('mouseleave')
    onmouseleave() {
    event.stopPropagation();
      if(this.product.imageOne) {
        if (this.product.imageOne != null) {
          this.imageSource = this.product.imageOne.formats.thumbnail.url;
        } else {
          this.imageSource = this.product.imageTwo.formats.thumbnail.url;
        }
      }else{
        if (this.product.imageOne != null) {
          this.imageSource = this.product.primaryImage.formats.thumbnail.url;
        } else {
          this.imageSource = this.product.secondaryImage.formats.thumbnail.url;
        }
      }
  }

  @HostListener('click', ['$event.target'])
    onClick() {
      this.setfilter.emit(this.product);
   }

  constructor(private appState: AplicationStateService, private router: Router, public  tarnslator: TranslationService) { }

  ngOnInit() {
    this.lang = this.appState.language;
    if (this.product.primaryImage) {
      this.imageSource = this.product.primaryImage.formats.thumbnail.url;
    } else {
      this.imageSource = this.product.imageOne.formats.thumbnail.url;
    }
  }

  ngAfterViewInit() {
    this.inTheViewController = new InTheViewController(this.wrapper, this.tpl, this.vc);
  }

}
